import { faEye, faEyeSlash } from "@fortawesome/pro-regular-svg-icons";
import { Checkbox } from "@mui/material";

import { Icon } from "@/components/ui-v2";

const stopPropagation = (e: { stopPropagation: () => void }) =>
  e.stopPropagation();

interface LayerVisibilityFieldProps {
  visible: boolean;
  allParentsVisible: boolean;
  setVisible: (visible: boolean) => void;
}

export const LayerVisibilityField = (props: LayerVisibilityFieldProps) => {
  const { visible, allParentsVisible, setVisible } = props;

  return (
    <Checkbox
      checked={visible}
      onChange={(e) => setVisible(allParentsVisible ? e.target.checked : true)}
      onClick={stopPropagation}
      icon={<Icon icon={faEyeSlash} size="small" />}
      checkedIcon={<Icon icon={faEye} size="small" />}
      size="small"
      color="default"
      sx={{
        opacity: allParentsVisible ? 1 : 0.5,
      }}
    />
  );
};
